import { Spin } from 'antd';
import 'antd/es/spin/style/css';

const BtnLoader = ({ size="small" }) => {
    return (
        <div className="btn-loader">
            <Spin size={size} />
        </div>
    )
};

export default BtnLoader;